import SvgIcon from "@mui/material/SvgIcon";
import { useTheme } from "@mui/material";

export const WorkloadIdentityBindingsEmptyStateStepThree = ({ ...props }) => {
  const theme = useTheme();

  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 208 144" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="1"
          y="1"
          width="190"
          height="126"
          rx="7"
          fill={theme.palette.background.default}
          stroke={theme.palette.background.lightest}
          stroke-width="2"
        />
        <path
          d="M64 64C64 61.7909 65.7909 60 68 60H124C126.209 60 128 61.7909 128 64C128 66.2091 126.209 68 124 68H68C65.7909 68 64 66.2091 64 64Z"
          fill={theme.palette.background.light}
        />
        <path
          d="M64 76C64 73.7909 65.7909 72 68 72H124C126.209 72 128 73.7909 128 76C128 78.2091 126.209 80 124 80H68C65.7909 80 64 78.2091 64 76Z"
          fill={theme.palette.background.light}
        />
        <path
          d="M103.999 28V43.9992C108.417 43.9992 111.999 40.4179 111.999 35.9992C111.999 31.5804 108.417 28 103.999 28Z"
          fill="currentColor"
        />
        <path
          d="M96 44C100.418 44 104 40.4183 104 36C104 31.5817 100.418 28 96 28C91.5817 28 88 31.5817 88 36C88 40.4183 91.5817 44 96 44Z"
          fill="currentColor"
        />
        <path
          d="M80 36C80 40.4179 83.5813 44 88 44V28C83.5813 28 80 31.5813 80 36Z"
          fill="currentColor"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M91.1514 101.77H97.9847C99.7988 101.77 101.278 103.292 101.278 105.16V111.608C101.278 113.477 99.7988 114.999 97.9847 114.999L90.2933 115C88.4793 115 87 113.478 87 111.609V105.161C87 103.725 87.8783 102.468 89.148 101.982L88.4125 99.1485C88.0749 97.8508 88.2845 96.5303 88.8929 95.4447C90.2099 93.1006 93.0896 92.3061 95.3656 93.6601C96.4182 94.2855 97.24 95.3234 97.5776 96.621C97.7185 97.1672 97.4032 97.7277 96.8736 97.8728C96.345 98.0189 95.8006 97.6942 95.6578 97.1481C95.2664 95.6433 93.7481 94.7371 92.2799 95.141C90.8173 95.5449 89.939 97.1099 90.3304 98.6187L91.1503 101.769L91.1514 101.77ZM100.57 96.0798L101.466 94.4785C101.686 94.0879 101.557 93.5876 101.178 93.3613C100.799 93.135 100.313 93.2677 100.093 93.6592L99.1942 95.2605C98.9744 95.6511 99.1051 96.1514 99.4845 96.3777C99.8638 96.604 100.35 96.4703 100.57 96.0798ZM101.777 98.4898L103.332 97.5655C103.712 97.3392 103.842 96.8389 103.623 96.4484C103.403 96.0578 102.916 95.9242 102.538 96.1504L100.982 97.0747C100.603 97.301 100.475 97.8014 100.694 98.1919C100.914 98.5824 101.398 98.7161 101.777 98.4898ZM102.409 100.993C101.967 100.993 101.611 100.627 101.611 100.174C101.611 99.7215 101.967 99.3548 102.409 99.3548H104.204C104.644 99.3548 105 99.7215 105 100.174C105 100.627 104.644 100.993 104.204 100.993H102.409ZM93.3429 111.284H94.9353V109.234C95.1402 109.134 95.3229 108.996 95.4778 108.83C95.8303 108.482 96.0491 107.993 96.0491 107.451C96.0491 106.909 95.8293 106.42 95.4778 106.072C95.1402 105.71 94.6654 105.485 94.1395 105.485C93.6137 105.485 93.137 105.71 92.7994 106.072C92.4469 106.42 92.2281 106.91 92.2281 107.451C92.2281 107.994 92.4479 108.482 92.7994 108.83C92.9543 108.996 93.1388 109.134 93.3419 109.234V111.284H93.3429Z"
          fill="#2FC089"
        />
        <path
          d="M1 8C1 4.13401 4.13401 1 8 1H184C187.866 1 191 4.13401 191 8V15H1V8Z"
          fill={theme.palette.background.light}
          stroke={theme.palette.background.lightest}
          stroke-width="2"
        />
        <circle
          cx="192"
          cy="128"
          r="16"
          fill="url(#paint0_linear_2650_28875)"
        />
        <path
          d="M190.086 127.336H191.289C191.674 127.336 191.992 127.271 192.242 127.141C192.492 127.005 192.677 126.818 192.797 126.578C192.922 126.333 192.984 126.049 192.984 125.727C192.984 125.435 192.927 125.177 192.812 124.953C192.703 124.724 192.534 124.547 192.305 124.422C192.076 124.292 191.786 124.227 191.438 124.227C191.161 124.227 190.906 124.281 190.672 124.391C190.438 124.5 190.25 124.654 190.109 124.852C189.969 125.049 189.898 125.289 189.898 125.57H187.641C187.641 124.945 187.807 124.401 188.141 123.938C188.479 123.474 188.932 123.112 189.5 122.852C190.068 122.591 190.693 122.461 191.375 122.461C192.146 122.461 192.82 122.586 193.398 122.836C193.977 123.081 194.427 123.443 194.75 123.922C195.073 124.401 195.234 124.995 195.234 125.703C195.234 126.062 195.151 126.411 194.984 126.75C194.818 127.083 194.578 127.385 194.266 127.656C193.958 127.922 193.583 128.135 193.141 128.297C192.698 128.453 192.201 128.531 191.648 128.531H190.086V127.336ZM190.086 129.047V127.883H191.648C192.268 127.883 192.812 127.953 193.281 128.094C193.75 128.234 194.143 128.438 194.461 128.703C194.779 128.964 195.018 129.273 195.18 129.633C195.341 129.987 195.422 130.38 195.422 130.812C195.422 131.344 195.32 131.818 195.117 132.234C194.914 132.646 194.628 132.995 194.258 133.281C193.893 133.568 193.466 133.786 192.977 133.938C192.487 134.083 191.953 134.156 191.375 134.156C190.896 134.156 190.424 134.091 189.961 133.961C189.503 133.826 189.086 133.625 188.711 133.359C188.341 133.089 188.044 132.75 187.82 132.344C187.602 131.932 187.492 131.445 187.492 130.883H189.75C189.75 131.174 189.823 131.435 189.969 131.664C190.115 131.893 190.315 132.073 190.57 132.203C190.831 132.333 191.12 132.398 191.438 132.398C191.797 132.398 192.104 132.333 192.359 132.203C192.62 132.068 192.818 131.88 192.953 131.641C193.094 131.396 193.164 131.112 193.164 130.789C193.164 130.372 193.089 130.039 192.938 129.789C192.786 129.534 192.57 129.346 192.289 129.227C192.008 129.107 191.674 129.047 191.289 129.047H190.086Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2650_28875"
            x1="176"
            y1="112"
            x2="208.789"
            y2="143.17"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#9147FF" />
            <stop offset="1" stop-color="#4C35E8" />
          </linearGradient>
        </defs>
      </svg>
    </SvgIcon>
  );
};
